import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DateFormatService {
    public short24 = "dd-MM-yyyy HH:mm";

    constructor() { }
}
